let analyticsSupported = { supported: true };
export const setAnalyticsSupport = (isSupported: boolean) => {
  analyticsSupported.supported = isSupported;
};
